import React from "react";
import { MovingWebsite } from "../../components/UnderConstruction";
import { InstaEmbedRow } from "../../components/Embeds/components/embeds/EmbedRow";

export function artplushie() {
return ( 
 <>
<div className="row">
<div className="col"><MovingWebsite/>
</div>
</div>
<InstaEmbedRow
    url1="https://www.instagram.com/p/CV1_YK0hPw-"
    url2="https://www.instagram.com/p/CWlkkews7qu"
    url3="https://www.instagram.com/p/CHa5-2kMyWJ"
/>
<InstaEmbedRow
    url1="https://www.instagram.com/p/Cd_1xsRByF1"
    url2="https://www.instagram.com/p/CeCHXQtP0fT"
    url3="https://www.instagram.com/p/CHa5-2kMyWJ"
/>
<InstaEmbedRow
    url1="https://www.instagram.com/p/C0FPoRsuA9_"
    url2="https://www.instagram.com/p/CZ0lf_GLLnh"
    url3="https://www.instagram.com/p/C1nEspRPFMY"
/>
</>
);
}
